import Upsertable from '@/models/Upsertable'
import { useDepotStore } from '@/stores/depotStore'
import { useModelName } from '@/composables/useModelName.js'
import { ModelRegistry } from '@/models/modelRegistry.js'

export default class Depot extends Upsertable {
  static store() {
    return useDepotStore()
  }

  store() {
    return Depot.store()
  }

  static find(uuid) {
    const obj = Depot.store().find(uuid)
    let depot = new Depot()
    return Object.assign(depot, obj)
  }
}

useModelName(Depot, "Depot")
ModelRegistry.register(Depot, "Depot")